import React from "react";
import PropTypes from "prop-types";

const ChocolateTableChoice = (props) => {
    const { question, selectedValue, onChange } = props;

    return (
        <>
            <div className="controller-container">
                <span className={"question"}>{question.q}</span>
                <div className="chocolate-table-6 labels-container">
                    {question.answers.map((property, i) => {
                        return (
                            <div
                                key={i}
                                onClick={() => onChange(property)}
                                className={`label-container d-flex flex-align-center flex-justify-center W-100
                                            ${
                                                property === selectedValue
                                                    ? "selected"
                                                    : ""
                                            }`}
                            >
                                <div className="label-inner d-flex flex-align-center flex-justify-center">
                                    <span className="chocolate-property">
                                        {property}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

ChocolateTableChoice.propTypes = {
    question: PropTypes.shape({
        answers: PropTypes.arrayOf(PropTypes.string),
        other: PropTypes.bool,
        q: PropTypes.string,
    }),
    selectedValue: PropTypes.string,
    onChange: PropTypes.func,
};

export default ChocolateTableChoice;
